import { createContext } from 'react';

export default createContext({
  hideHeader: false,
  headerColor: 'white',
  headerHeight: '',
  setHideHeader: () => {},
  setHeaderColor: () => {},
})
